function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgPc05 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.46664,72.03246q-2.95735-1.97157-5.92053-3.62327a85.40261,85.40261,0,0,0-15.14445-6.70566,86.35846,86.35846,0,0,0-23.14123-4.2572",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.1631683441058502px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.65331,57.3998A101.39,101.39,0,0,0,3.93046,68.0079",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.1631683441058502px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.01651,
    cy: 72.26336,
    rx: 3.09079,
    ry: 7.66109,
    transform: "translate(-15.24561 121.53606) rotate(-67.09845)",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.1631683441058502px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.51275,78.01951c-1.01724,2.408-6.68039,2.316-12.649-.20542s-9.98247-6.51749-8.96522-8.92546",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.1631683441058502px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.67442,
    cy: 70.90959,
    rx: 7.17794,
    ry: 2.89587,
    transform: "translate(-17.10963 5.58347) rotate(-14.31642)",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.1631683441058502px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.76788,69.25611c.60562,2.37311-3.67187,5.51381-9.554,7.01495s-11.14158.79428-11.7472-1.57883",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.1631683441058502px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.57783,
    cy: 76.80574,
    rx: 2.89587,
    ry: 7.17794,
    transform: "translate(-27.56864 125.85169) rotate(-89.6041)",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.1631683441058502px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.72751,78.02383c-.01693,2.44911-4.9518,4.4005-11.02236,4.35855s-10.978-2.06134-10.96107-4.51045",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.1631683441058502px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "76.401 61.702 80.803 59.539 91.181 64.544 91.544 68.407",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.1631683441058502px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "42.808 46.487 40.916 50.623 43.554 49.653 41.411 55.51 43.857 53.18 49.77 66.853 54.686 53.329 57.46 55.414 55.632 50.914 58.241 51.833 55.774 47.027",
    style: {
      fill: "none",
      stroke: "#ff7d49",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2121804978156951px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62.71482,
    y1: 44.85309,
    x2: 64.18849,
    y2: 47.84315,
    style: {
      fill: "none",
      stroke: "#ff7d49",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2121804978156951px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.85221,20.66761a18.4846,18.4846,0,0,0,16.27876-.7793",
    style: {
      fill: "none",
      stroke: "#ff7d49",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2121804978156951px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.14854,37.63653c9.01221,4.5061,26.88125,4.35072,35.11654-.9323",
    style: {
      fill: "none",
      stroke: "#ff7d49",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2121804978156951px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.66946,36.85515A8.84415,8.84415,0,0,1,60.682,45.53921a50.46093,50.46093,0,0,1-21.6637-.0361A8.80428,8.80428,0,0,1,32.26809,38.098a8.70385,8.70385,0,0,1,.44347-4.18732c.05672-.14957.10831-.28878.17019-.428a37.27477,37.27477,0,0,1,3.97586-7.60111,50.55482,50.55482,0,0,1,3.9759-5.1929c.64977-.74774,1.2892-1.44389,1.90286-2.08333a8.84415,8.84415,0,0,1,11.90189-.86121q1.22988.98238,2.32572,1.99055a42.38113,42.38113,0,0,1,9.33379,12.3402c.196.40222.38676.789.56207,1.17574A8.6792,8.6792,0,0,1,67.66946,36.85515Z",
    style: {
      fill: "none",
      stroke: "#276ef1",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.2121804978156951px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.08787,
    y1: 42.90871,
    x2: 34.49652,
    y2: 49.55695,
    style: {
      fill: "none",
      stroke: "#ff7d49",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2121804978156951px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.75286,48.68447c.00148.78815-1.86909,1.43059-4.178,1.43491s-4.18191-.63109-4.18338-1.41924c-.00094-.50093.75433-.943,1.89773-1.19978a10.682,10.682,0,0,1,2.2803-.23514,11.46939,11.46939,0,0,1,1.62753.1091C67.69793,47.58815,68.75175,48.09335,68.75286,48.68447Z",
    style: {
      fill: "none",
      stroke: "#ff7d49",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2121804978156951px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.69957,50.46533c-.016.788-1.90034,1.38881-4.20881,1.342s-4.16689-.72362-4.1509-1.51162c.01016-.50082.775-.926,1.92386-1.15742a10.6815,10.6815,0,0,1,2.285-.18454,11.46893,11.46893,0,0,1,1.62471.14514C37.6692,49.3459,38.71156,49.87434,38.69957,50.46533Z",
    style: {
      fill: "none",
      stroke: "#ff7d49",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2121804978156951px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.55615,
    cy: 31.33332,
    rx: 4.55784,
    ry: 5.2628,
    transform: "translate(-1.58996 2.66863) rotate(-3.03599)",
    style: {
      fill: "none",
      stroke: "#276ef1",
      strokeMiterlimit: 10,
      strokeWidth: "1.2121804978156951px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.77748,30.9112c-.73933,2.46447-2.81083,4.02971-4.61586,3.48353A2.85318,2.85318,0,0,1,33.49645,32.976a37.37271,37.37271,0,0,1,3.97642-7.59984,3.373,3.373,0,0,1,.373.07992C39.65093,25.9956,40.52348,28.44006,39.77748,30.9112Z",
    style: {
      fill: "none",
      stroke: "#276ef1",
      strokeMiterlimit: 10,
      strokeWidth: "1.2121804978156951px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.65743,25.24364a2.52432,2.52432,0,0,0-.65941.10657c-1.81171.53952-2.6776,2.984-1.93826,5.45512.73934,2.46446,2.81081,4.02972,4.62252,3.48354a3.17615,3.17615,0,0,0,2.05816-2.46445v-.00667",
    style: {
      fill: "none",
      stroke: "#276ef1",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.2121804978156951px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.54706,33.60784a7.65163,7.65163,0,0,0,6.47688-6.47719h.15483a7.65163,7.65163,0,0,0,6.47688,6.47719v.15478a7.65162,7.65162,0,0,0-6.47683,6.47663h-.15493a7.6516,7.6516,0,0,0-6.47683-6.47663Z",
    style: {
      fill: "#ffcd4d",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.61562,16.909a4.44673,4.44673,0,0,0,3.764-3.76419h.09a4.44671,4.44671,0,0,0,3.764,3.76419V16.999a4.44672,4.44672,0,0,0-3.764,3.76387h-.09a4.44672,4.44672,0,0,0-3.764-3.76387Z",
    style: {
      fill: "#ffcd4d",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.86343,41.30258a2.762,2.762,0,0,0,2.338-2.33806h.05589a2.762,2.762,0,0,0,2.33794,2.33806v.05587a2.762,2.762,0,0,0-2.33793,2.33785h-.05592a2.762,2.762,0,0,0-2.33793-2.33785Z",
    style: {
      fill: "#ffcd4d",
      fillRule: "evenodd"
    }
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgPc05);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/PC05.77042d1896612227c0a6b6317282b0da.svg";